<template>
  <div class="content">
    <section class="page-intro">
      <p>
        <span class="f-ticker">Otter</span>
        <span class="accent-1"> • </span>
        <span class="f-ticker">2023</span>
        <span class="accent-1"> &#8212; </span>
        <span class="f-ticker">2025</span>
      </p>
      <p class="tag-list">
        <span class="tag icon-text">UX</span>
        <span class="tag icon-text">•</span>
        <span class="tag icon-text">UI</span>
        <span class="tag icon-text">•</span>
        <span class="tag icon-text">Brand</span>
      </p>
    </section>

    <section class="image-gallery">
      <div class="row">
        <div class="column">
          <video
            autoplay="true"
            loop="true"
            muted="true"
            playsinline="true"
            width="100%"
          >
            <source
              src="@/assets/work/otter/AppCarousel.mp4"
              type="video/mp4"
            />
          </video>
          <p>
            <img
              src="@/assets/work/otter/ecosystem_REPLACE.png"
              alt="Otter"
              class="carousel-image"
            />
          </p>
          <p>
            <img
              src="@/assets/work/otter/web_placeholder.png"
              alt="Otter"
              class="carousel-image"
            />
          </p>
          <p>
            <img
              src="@/assets/work/otter/tee-01.png"
              alt="Otter"
              class="carousel-image"
            />
          </p>
          <p>
            <img
              src="@/assets/work/otter/ParentFlyer-01.png"
              alt="Otter"
              class="carousel-image"
            />
          </p>
          <p>
            <img
              src="@/assets/work/otter/Illos.png"
              alt="Otter"
              class="carousel-image"
            />
          </p>
        </div>
      </div>
    </section>
    <ViewMoreWork
      :previous-project="{ path: '/work/odyssey', name: 'Odyssey' }"
      :next-project="{ path: '/work/skullcandy', name: 'Skullcandy' }"
    />
  </div>
</template>

<style lang="scss" scoped>
.main-content {
  opacity: 1;
}
</style>

<script setup>
import { defineExpose } from "vue";
import { useAssetPreloader } from "@/composables/useAssetPreloader.js";
import ViewMoreWork from "@/components/projects/ViewMoreWork.vue";

// Define preload function that will be called before component is mounted
const preload = async () => {
  const { preloadAssets } = useAssetPreloader();

  // Specify exactly which assets this page needs
  const assets = [
    (await import("@/assets/work/otter/AppCarousel.mp4")).default,
    (await import("@/assets/work/otter/ecosystem_REPLACE.png")).default,
    (await import("@/assets/work/otter/web_placeholder.png")).default,
    (await import("@/assets/work/otter/tee-01.png")).default,
    (await import("@/assets/work/otter/ParentFlyer-01.png")).default,
    (await import("@/assets/work/otter/Illos.png")).default,
  ];

  await preloadAssets(assets);
};

// Expose preload method for external use
defineExpose({ preload });
</script>
